(() => {
  const ROOT_SELECTOR = '[data-yb-ultra-redesign]';
  const VIDEO_SELECTOR = '[data-yb-ultra-video], [data-yb-ultra-detail-video]';
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  const hydrateVideo = (video) => {
    const sources = Array.from(video.querySelectorAll('source[data-src]'));

    if (sources.length === 0) return;

    sources.forEach((source) => {
      const deferredSource = source.dataset.src;
      if (deferredSource) source.src = deferredSource;
      source.removeAttribute('data-src');
    });
    video.load();
  };

  const pauseVideos = (videos, exception) => {
    videos.forEach((video) => {
      if (video !== exception && !video.paused) video.pause();
    });
  };

  const playVideo = async (video, videos, motionPreference) => {
    if (motionPreference.matches) {
      video.pause();
      return;
    }

    hydrateVideo(video);
    pauseVideos(videos, video);

    try {
      await video.play();
    } catch (_error) {
      video.pause();
    }
  };

  const showReducedMotionPoster = (videos) => {
    videos.forEach((video) => {
      video.pause();
      try {
        video.currentTime = 0;
      } catch (_error) {
        // Some browsers block seeking until media metadata is available.
      }
    });
  };

  const initialiseUltraDetail = (root) => {
    if (!root || root.dataset.ybUltraReady === 'true') return;

    const videos = Array.from(root.querySelectorAll(VIDEO_SELECTOR));
    if (videos.length === 0) return;

    root.dataset.ybUltraReady = 'true';
    const motionPreference = window.matchMedia(REDUCED_MOTION_QUERY);

    if (motionPreference.matches) showReducedMotionPoster(videos);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;

          if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
            void playVideo(video, videos, motionPreference);
          } else {
            video.pause();
          }
        });
      },
      { threshold: [0, 0.25, 0.7] }
    );

    videos.forEach((video) => observer.observe(video));

    const handleMotionChange = (event) => {
      if (event.matches) {
        showReducedMotionPoster(videos);
        return;
      }

      videos.forEach((video) => {
        if (video.getBoundingClientRect().top < window.innerHeight && video.getBoundingClientRect().bottom > 0) {
          void playVideo(video, videos, motionPreference);
        }
      });
    };

    if (typeof motionPreference.addEventListener === 'function') {
      motionPreference.addEventListener('change', handleMotionChange);
    } else {
      motionPreference.addListener(handleMotionChange);
    }
  };

  const initialisePage = (scope = document) => {
    const root = scope.matches?.(ROOT_SELECTOR) ? scope : scope.querySelector(ROOT_SELECTOR);
    initialiseUltraDetail(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialisePage(), { once: true });
  } else {
    initialisePage();
  }

  document.addEventListener('shopify:section:load', (event) => initialisePage(event.target));
})();
